import type { LovProADTO } from '@/features/api/extranet/dto/Demande/PROA'
import { propertyStatusConfiguration, reglesConfiguration } from '@/features/domaine/regles-akto/PROA'
import { proaService } from '@/features/services/demande'
import { buildDemandeStore } from '../shared'
import type { ContratProADTO } from '@/features/api/extranet/dto/Demande/PROA'

export const useDemandePROAStore = buildDemandeStore<ContratProADTO, LovProADTO>({
  dispositif: 'PROA',
  demandeService: proaService,
  propertyStatusConfiguration,
  reglesConfiguration,
})

